import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { CreateContract, CreateContractVariables } from '@/graphql/contracts/_generated_/createContract.mutation';
import CreateContractMutation from '@/graphql/contracts/createContract.mutation.gql';
import { notificationService } from '@/services/notification/notification.client';

export default function useCreateContract() {
  const [_createContract, { data, loading }] = useMutation<CreateContract, CreateContractVariables>(
    CreateContractMutation,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      onCompleted: () => notificationService.open({
        title: 'Contract created',
        text: 'The contract is already available in the contact list',
        type: 'success'
      }),
    }
  );

  const createContract = (fields: CreateContractVariables) => {
    _createContract({
      variables: { ...fields }
    });
  };

  return {
    createContract,
    createdContract: data?.createContract,
    isLoadingCreateContract: loading,
  } as const;
}
